import * as React from "react";
import Terms from "src/pages/Terms";
import Layout from "@components/Layout";
import Head from "next/head";

const Index = () => {
  return (
    <Layout>
      <Head>
        <title>Inawo | Terms and Conditions</title>
        <meta
          name="description"
          content="Review Inawo terms and conditions for platform usage, account responsibilities, payments, and policies for users and vendors."
        />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
      </Head>
      <Terms />
    </Layout>
  );
};

export default Index;
